import { NgeExplorerConfig } from '../shared/types';

export class ConfigProvider {
  constructor(public config: NgeExplorerConfig) {}
}
